import React from 'react';
import { Select, Form, Input } from 'antd';
import { ButtonCommon, SelectCommon } from 'components/common';
import { CaretDown, Funnel, XCircle } from '@phosphor-icons/react';

import { StockOutOrderFilter } from 'models/InventoryDocument';
import MyRangePicker from '../DatePicker/MyRangePicker';
import { useGetAllTemplateEInvoicesQuery } from 'services';
import { removeVietnameseTones } from 'utils/removeVNTones.utils';
import { EInvoiceFilter } from 'types/invoice.type';
import { Dayjs } from 'dayjs';
interface FilterEInvoiceProps {
  initialFilter?: StockOutOrderFilter;
  onApplyFilter: (filter: EInvoiceFilter) => void;
  onClearFilter: () => void;
}

const FilterEInvoice: React.FC<FilterEInvoiceProps> = ({ initialFilter, onApplyFilter, onClearFilter }) => {
  const [form] = Form.useForm();
  const { data: templateEInvoiceData, isLoading } = useGetAllTemplateEInvoicesQuery({
    query: {
      year: new Date().getFullYear(),
    },
  });
  const handleClearFilter = () => {
    form.resetFields();
    form.setFieldsValue({});
    onClearFilter();
  };

  const handleApplyFilter = () => {
    const values = form.getFieldsValue();
    onApplyFilter({
      ...values,
    });
  };
  const onChange = (value: [Dayjs | null, Dayjs | null] | null) => {
    form.setFieldsValue({
      dateRange: value,
    });
  };
  return (
    <div className='bg-white rounded-lg overflow-hidden w-full h-full'>
      <div className='relative h-full'>
        <Form form={form} layout='vertical' initialValues={initialFilter} className='filter-form min-h-[650px]'>
          <div className='flex flex-col'>
            <Form.Item
              label={
                <span className='text-[14px] leading-[20px] font-medium text-[var(--textBlack100)]'>Mã tham chiếu</span>
              }
              name='MaTraCuu'
            >
              <Input
                placeholder='Nhập mã tham chiếu'
                allowClear={{
                  clearIcon: <XCircle color='black' weight='fill' size={18} className='!-mt-0.5 !-ml-1.5' />,
                }}
                className='w-full'
                size='large'
              />
            </Form.Item>
            <Form.Item
              label={
                <span className='text-[14px] leading-[20px] font-medium text-[var(--textBlack100)]'>
                  Thông tin khách hàng
                </span>
              }
              name='TTKhachHang'
            >
              <Input
                placeholder='Nhập thông tin khách hàng'
                allowClear={{
                  clearIcon: <XCircle color='black' weight='fill' size={18} className='!-mt-0.5 !-ml-1.5' />,
                }}
                className='w-full'
                size='large'
              />
            </Form.Item>
            <Form.Item
              label={
                <span className='text-[14px] leading-[20px] font-medium text-[var(--textBlack100)]'>
                  Thời gian tạo hoá đơn điện tử (tối đa 30 ngày)
                </span>
              }
              name='dateRange'
            >
              <MyRangePicker onChange={onChange} />
            </Form.Item>
            <Form.Item
              label={
                <span className='text-[14px] leading-[20px] font-medium text-[var(--textBlack100)]'>Loại hoá đơn</span>
              }
              name='KHHDon'
            >
              <SelectCommon
                loading={isLoading}
                showSearch
                placeholder='Chọn loại hoá đơn'
                options={templateEInvoiceData?.data?.templates
                  ?.filter((p) => p?.khmshDon === '2')
                  ?.map((p, index) => ({
                    label: [p?.thDon, p?.khhDon]?.filter(Boolean)?.join(' - '),
                    value: p?.khhDon,
                    key: index,
                  }))}
                filterOption={(input, option) => {
                  const label = removeVietnameseTones(option?.label?.toString());
                  const value = removeVietnameseTones(input);
                  return label.includes(value);
                }}
                selectType='filterSelect'
                className='text-[16px]'
                size='large'
              />
            </Form.Item>
            <Form.Item
              label={
                <span className='text-[14px] leading-[20px] font-medium text-[var(--textBlack100)]'>
                  Trạng thái hoá đơn
                </span>
              }
              name='TThaiHDon'
            >
              <Select
                placeholder='Chọn trạng thái hoá đơn'
                className='w-full'
                allowClear={{
                  clearIcon: <XCircle color='black' weight='fill' size={18} className='!-mt-0.5 !-ml-1.5' />,
                }}
                suffixIcon={<CaretDown color='black' size={18} />}
                options={[
                  { value: -1, label: 'Tất cả ' },
                  { value: 1, label: 'Nháp' },
                  { value: 2, label: 'Lỗi ký' },
                  { value: 3, label: 'Chưa gửi CQT' },
                  { value: 4, label: 'Đã cấp mã/tiếp nhận' },
                  { value: 5, label: 'CQT chưa phản hồi' },
                  { value: 6, label: 'Không đủ điều kiện cấp mã' },
                ]}
                size='large'
              />
            </Form.Item>
          </div>
        </Form>
        <div className='absolute bottom-0 p-[10px] w-full'>
          <div className='flex gap-6'>
            <ButtonCommon
              color='none'
              size='md'
              radius='rounded'
              className='min-w-[112px] hover:font-normal'
              onClick={handleClearFilter}
            >
              Xóa bộ lọc
            </ButtonCommon>
            <ButtonCommon
              color='primary'
              size='md'
              radius='rounded'
              fullWidth
              className='flex justify-center items-center'
              onClick={handleApplyFilter}
              icon={<Funnel size={16} />}
              iconPosition='right'
            >
              Áp dụng bộ lọc
            </ButtonCommon>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterEInvoice;
